import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useMemo, useRef, useState } from "react";
import * as Yup from "yup";
import { Input } from "../../controls/formik-wrapped";
var DEFAULT_VALUE = {
  name: "",
  email: "",
  phone: "",
  title: "",
  linkedin: ""
};
var KEYS = Object.freeze(Object.keys(DEFAULT_VALUE));

var compareValues = function compareValues(a, b) {
  if (a === b || !a || !b) return true;
  var matches = KEYS.reduce(function (matched, key) {
    return matched && a[key] === b[key];
  }, true);
  return matches;
};

var aggregateErrors = function aggregateErrors(errors) {
  return Object.values(errors).reduce(function (errs, err) {
    return err ? [].concat(_toConsumableArray(errs), [err]) : errs;
  }, []);
};

export var ContactInfoEditor = function ContactInfoEditor(_ref) {
  var contact_info = _ref.contact_info,
      onValueChanged = _ref.onValueChanged,
      setValidateFunction = _ref.setValidateFunction;

  var _useState = useState(contact_info),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      isValid = _useState4[0],
      setIsValid = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      validReason = _useState6[0],
      setValidReason = _useState6[1];

  var previousValue = useRef(contact_info);
  var validationSchema = useMemo(function () {
    var schema = Yup.object({
      name: Yup.string().ensure().trim().required(),
      email: Yup.string().ensure().trim().email().required(),
      phone: Yup.string().ensure().trim().matches(/^\(?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})$/, "Only US-format phone numbers are accepted at this time").required(),
      title: Yup.string().ensure().trim().required(),
      linkedin: Yup.string().ensure().trim().optional().matches(/^$|^(?:(?:https:\/\/)?(?:www\.)?(?:linkedin\.com|linked\.in)\/in\/)?[a-z0-9_.-]+\/?$/i, "Must be a LinkedIn profile URL or just your username")
    });
    return schema;
  }, []);
  useEffect(function () {
    if (isValid === undefined) return;
    if (compareValues(previousValue.current, currentValue)) return;
    previousValue.current = currentValue;

    if (isValid) {
      onValueChanged(currentValue);
    }
  }, [currentValue, isValid, onValueChanged, validReason]);
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: contact_info !== null && contact_info !== void 0 ? contact_info : _objectSpread({}, DEFAULT_VALUE),
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: function onSubmit(_values, _ref2) {
      var setSubmitting = _ref2.setSubmitting;
      setSubmitting(false);
    }
  }, function (_ref3) {
    var isValid = _ref3.isValid,
        dirty = _ref3.dirty,
        values = _ref3.values,
        errors = _ref3.errors,
        validateForm = _ref3.validateForm;
    setValidateFunction === null || setValidateFunction === void 0 ? void 0 : setValidateFunction(validateForm);
    setIsValid(isValid);
    if (isValid && dirty && !compareValues(currentValue, values)) setCurrentValue(values);
    var aggregatedErrors = aggregateErrors(errors);
    setValidReason(aggregatedErrors.length ? aggregatedErrors.join("; ") : undefined);
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Input, {
      label: "Name",
      name: "name",
      fullWidth: true,
      required: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "name",
      component: "div"
    }), /*#__PURE__*/React.createElement(Input, {
      label: "Title",
      name: "title",
      fullWidth: true,
      required: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "title",
      component: "div"
    }), /*#__PURE__*/React.createElement(Input, {
      label: "Phone",
      name: "phone",
      type: "tel",
      fullWidth: true,
      required: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "phone",
      component: "div"
    }), /*#__PURE__*/React.createElement(Input, {
      label: "Email",
      name: "email",
      type: "email",
      fullWidth: true,
      required: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "email",
      component: "div"
    }), /*#__PURE__*/React.createElement(Input, {
      clearable: true,
      label: "LinkedIn",
      name: "linkedin",
      type: "url",
      fullWidth: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "linkedin",
      component: "div"
    }));
  });
};